import { Grid, Typography } from '@material-ui/core';
import React from 'react';

const LabelInput: React.FC<ILabelInputProps> = (props) => {
	return (
		<Grid container={true} direction='row' alignItems='center' spacing={2}>
			<Grid item={true} xs={5}>
				<Typography variant='subtitle2' color='inherit'>
					<strong>{props.label}</strong>
				</Typography>
			</Grid>
			<Grid item={true} xs={!!props.renderTooltip ? 6 : 7}>
				{props.renderInput()}
			</Grid>
			{!!props.renderTooltip && (
				<Grid item={true} xs={1}>
					{props.renderTooltip()}
				</Grid>
			)}
		</Grid>
	);
};

interface ILabelInputProps {
	label: string;
	renderInput: () => JSX.Element;
	renderTooltip?: () => JSX.Element;
}

export default LabelInput;



// WEBPACK FOOTER //
// ./src/components/shared/label-input.component.tsx